import { render, staticRenderFns } from "./TransferredOrdersTable.vue?vue&type=template&id=38eaf8bd&scoped=true"
import script from "./TransferredOrdersTable.vue?vue&type=script&lang=ts"
export * from "./TransferredOrdersTable.vue?vue&type=script&lang=ts"
import style0 from "./TransferredOrdersTable.vue?vue&type=style&index=0&id=38eaf8bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38eaf8bd",
  null
  
)

export default component.exports